import axios from "axios"


const server = process.env.NODE_ENV === 'production' ? 'https://recarga-te.com'
  : process.env.NODE_ENV === 'productionCam' ? 'https://recargasasec.com'
    : 'http://localhost:8091'

const server2 = process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'productionCam' ? 'https://recargasasec.com' : 'http://localhost:8091'


/**Methods**/
export const POST = 'post'
export const GET = 'get'
export const PATCH = 'patch'
export const DELETE = 'delete'
export const PUT = 'put'

/**Routes**/
const VERSION = "version"

/**Config Builder
 * @constructor
 * @param requestMethod{string}is the request method to be used when making the request -  Ej 'post'
 * @param route{string}  is the server URL that will be used for the request - Ej '/quienSoy'
 * @param params{string} are the URL parameters to be sent with the request -  Ej ['id','day']
 * @param data{Object} is the data to be sent as the request body -Only applicable for request methods 'PUT', 'POST', and 'PATCH'
 * @param headers
 * @param camType
 * @param onUploadProgress
 * **/
function config(requestMethod, route, data, params, headers, camType = '', onUploadProgress, isRecargate = true) {
  return {
    url: route,
    method: requestMethod,
    baseURL: isRecargate ? server : server2,
    headers: {Authorization: `Bearer ${window.localStorage[`token`]}`},
    params, data, onUploadProgress
  }
}

export function execute({method, route, data, params, headers, responseType, server, $store, camType, onUploadProgress}, isRecargate = true) {
  console.log(server)
  return new Promise((resolve, reject) => {
    let conf = new config(method, route, data, params, headers, camType, onUploadProgress, isRecargate)
    if (server) conf.baseURL = server
    if (responseType) conf.responseType = responseType
    if (headers) Object.keysProp(headers).forEach(k => conf.headers[k] = headers[k])
    console.log('config terminada', conf)
    awesomeLog("Request", {endpoint: `${conf.baseURL}${conf.url}`, method: conf.method, params, data})
    if ($store) $store.commit('ponerBarra')
    axios.request(conf).then(r => {
      if ($store) $store.commit('quitarBarra')
      awesomeLog("Response", r)
      resolve(r.data)
    }).catch(e => {
      if ($store) $store.commit('quitarBarra')
      awesomeLog("Error", e.response.data)
      reject(e.response.data.message || 'Error inesperado, intenta mas tarde o contacta con soporte')
    })

  })
}

function awesomeLog(titulo, obj) {
  console.log("*******" + titulo + "************")
  console.log(obj)
  console.log("*******Fin " + titulo + "*********")
  // if (obj.data && obj.data.message)
  //   M.toast({html: obj.data.message})
}




